var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38994 1.14778L10.7999 3.96778C10.9899 4.35778 11.4999 4.72778 11.9299 4.80778L14.4799 5.22778C16.1099 5.49778 16.4899 6.67778 15.3199 7.85778L13.3299 9.84778C12.9999 10.1778 12.8099 10.8278 12.9199 11.2978L13.4899 13.7578C13.9399 15.6978 12.8999 16.4578 11.1899 15.4378L8.79994 14.0178C8.36994 13.7578 7.64994 13.7578 7.21994 14.0178L4.82994 15.4378C3.11994 16.4478 2.07994 15.6978 2.52994 13.7578L3.09994 11.2978C3.18994 10.8178 2.99994 10.1678 2.66994 9.83778L0.679942 7.84778C-0.490058 6.67778 -0.110058 5.49778 1.51994 5.21778L4.06994 4.79778C4.49994 4.72778 5.00994 4.34778 5.19994 3.95778L6.60994 1.13778C7.37994 -0.382224 8.61994 -0.382223 9.38994 1.14778Z",
    fill: "#333448",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.0b74741bf25d776688bbd144c335d041.svg";
export { ForwardRef as ReactComponent };